// extracted by mini-css-extract-plugin
export default {"header-root":"TaskHeader_header-root__wimy9","task-status":"TaskHeader_task-status__GmTEp","appointment":"TaskHeader_appointment__y4Mwu"};